import { isPrivate } from '@wix/communities-forum-client-commons';

export const isFollowButtonVisible = (category, canSubscribe) => {
  return !isPrivate(category) || canSubscribe;
};
